import axios from 'axios'
import store from './store'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

if (process.env.NODE_ENV === 'development') {
  axios.interceptors.request.use(function (config) {
    console.log(`${config.method.toUpperCase()}: ${config.url}`)
    return config
  }, function (error) {
    return Promise.reject(error)
  })
}

axios.interceptors.request.use(function (config) {
  store.commit('setLoading', true)
  return config
}, function (error) {
  store.commit('setLoading', false)
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  store.commit('setLoading', false)
  return response
}, function (error) {
  store.commit('setLoading', false)

  if (!error.response) {
    alert('Er is iets fout gegaan. Probeer het later opnieuw.')

    return Promise.reject(error)
  }

  if (error.response.status === 401 || error.response.status === 403) { // unauthorized when token expired
    if (window.location.pathname !== '/login' && window.location.pathname !== '/verify') {
      store.commit('auth/logout')
    }
  } else if (error.response.status >= 500) {
    // if (process.env.NODE_ENV !== 'development') {
    //   router.push('/')
    // }

    alert('Er is iets fout gegaan. Probeer het later opnieuw.')
  }

  return Promise.reject(error)
})
